import instance from "services/axiosServices";
import leadsWebEnviroment from "utils/leadsWebEnviroment";

export const postEtiquetaLead = async (params: {
  idLeadCorretor: string;
  idEtiqueta: string;
}) => {
  const url = `${leadsWebEnviroment}/commom/leads/etiqueta-lead/v1`;
  const response = await instance.post(url, params);
  return response?.data;
};

export const postEtiquetaLeadMultiple = async (params: {
  idsLeadCorretor: string[];
  idEtiqueta: string;
}) => {
  const url = `${leadsWebEnviroment}/commom/leads/etiqueta-lead-massa/v1`;
  const response = await instance.post(url, params);
  return response?.data;
};
